import { getCurrency } from "locale-currency";

export const formatCurrency = (value, locale = "en-US") => {
  if (value === undefined || value === null || isNaN(value)) return "";

  const currency = getCurrency(locale) || "USD";

  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency,
    minimumFractionDigits: 2,
  }).format(Number(value));
};
